export default "__VITE_ASSET__CiVbFAa$__"